export default "__VITE_ASSET__DsUBr4xC__"